import React, { useMemo } from 'react';
import GlobalLayout from 'components/common/general/layouts/GlobalLayout';
import { useHistory } from 'react-router-dom';
import ProductTemplateSidebar from 'components/common/rfq/ProductTemplateSidebar';
import { PRODUCT_TEMPLATE_CARD_DATA } from 'global/checklists-helpers/ProductTemplateChecklistHelper';
import RFQChecklistOptionHeader from 'components/common/headers/RFQChecklistOptionHeader';
import GeneratePDFPageStore, { PageStoreContext } from 'store/pages/rfq/rfq-template/generate-pdf/pageStore';
import RFQGeneratePdf from 'components/rfq/product-template/rfq-generate-pdf';
import useRfqTemplate from 'global/hooks/useRfqTemplate';
import { createStyles } from '../../../../globalStyles';

const RFQGeneratePdfPage = (): JSX.Element => {
  const pageStore = useMemo(() => new GeneratePDFPageStore(), []);

  const history = useHistory();
  const { templateId, pageType } = useRfqTemplate();

  if (!templateId) return <></>;

  const returnBack = (): void => {
    history.push(`/product-template-checklist/${templateId}?type=${pageType}`);
  };

  const classes = createStyles();
  return (
    <GlobalLayout
      leftSection={<ProductTemplateSidebar />}
      rightSection={
        <div className={classes.pageWrapper}>
          <RFQChecklistOptionHeader
            title={PRODUCT_TEMPLATE_CARD_DATA.GENERATE_PDF.title}
            subtitle={PRODUCT_TEMPLATE_CARD_DATA.GENERATE_PDF.text}
            onRedirectBack={returnBack}
          />
          <PageStoreContext.Provider value={pageStore}>
            <RFQGeneratePdf />
          </PageStoreContext.Provider>
        </div>
      }
    />
  );
};

export default RFQGeneratePdfPage;
